export const Themes = [
  {
    id: 1,
    theme: {
      primary: "#000000",
      secondary: "#ffffff",
      primaryButton: "#e5cc99",
      secondaryButton: "#d7d1cb",
      accent: "#bea75c",
    },
  },
  {
    id: 2,
    theme: {
      primary: "#2a2538",
      secondary: "#e9e8e4",
      primaryButton: "#2a2538",
      secondaryButton: "#fefff5",
      accent: "#ebc5c5",
    },
  },
  {
    id: 3,
    theme: {
      primary: "#0f1419",
      secondary: "#ffffff",
      primaryButton: "#1d9bf0",
      secondaryButton: "#f7f7f7",
      accent: "#8ecdf7",
    },
  },
  {
    id: 4,
    theme: {
      primary: "#e5fffd",
      secondary: "#0b0c12",
      primaryButton: "#66fcf1",
      secondaryButton: "#202833",
      accent: "#c5c6c8",
    },
  },
  {
    id: 5,
    theme: {
      primary: "#444444",
      secondary: "#f7f7fc",
      primaryButton: "#22baa0",
      secondaryButton: "#ffffff",
      accent: "#5e36ca",
    },
  },
];
